


































































import Vue from "vue";
import dayjs from "dayjs";
import eventBus from "@/services/eventBus";
import api from "../services/api";
import BookingTemplateItems from "../components/BookingTemplateItems.vue";
import { BookingTemplateItem, BookingTemplateListItem } from "../models/BookingTemplate";
import { t } from "@/plugins/i18n";

// K2D "Törzs -> Könyvelési sablonok" (w_popupu_hmboktranstemp) lista portja.
// A szerkesztés/új sablon külön oldalon (route) történik (BookingTemplateEditor).
// A sor lenyitható (sávok gomb) — a tételek egyetlen tábláját mutatja (TransactionsView minta), amelyben
// soronként a dimenziók is lenyithatók; a törlés ugyanabban a detail-sorban sárga megerősítővel (isDeletion).

interface Data {
  templates: BookingTemplateListItem[];
  rowItems: Record<number, BookingTemplateItem[]>;
  isDeletion: boolean;
  columns: any[];
}

interface Methods {
  formatDate(d: string): string;
  reload(): Promise<void>;
  createTemplate(): void;
  editTemplate(item: BookingTemplateListItem): void;
  collapseAll(): void;
  showItems(item: BookingTemplateListItem): Promise<void>;
  askDelete(item: BookingTemplateListItem): void;
  confirmDelete(item: BookingTemplateListItem): Promise<void>;
  cancelDelete(item: BookingTemplateListItem): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  name: "BookingTemplateView",

  components: {
    BookingTemplateItems,
  },

  data(): Data {
    return {
      templates: [],
      rowItems: {},
      isDeletion: false,
      columns: [
        // Akció-oszlop: legelöl, fejléc nélkül (sávok / törlés / szerkesztés).
        { cell: "commandCell", title: "", width: "150px", filterable: false, sortable: false },
        { field: "name", title: t("Nev") },
        { field: "accEvent", title: t("GazdasagiEsemeny") },
        { field: "remark", title: t("Megjegyzes") },
        { field: "createdBy", title: t("Letrehozo"), width: "160px" },
        { field: "insDate", title: t("Letrehozva"), width: "140px", cell: "insDateCell" },
        { width: 0 },
      ],
    };
  },

  async mounted() {
    await this.reload();
  },

  methods: {
    formatDate(d: string): string {
      return d ? dayjs(d).format("YYYY.MM.DD.") : "";
    },

    async reload() {
      eventBus.$emit("busy-message", true);
      try {
        const list = await api.GetBookingTemplates();
        // A 'selected' UI-flaget kezdőértékkel vesszük fel, hogy reaktív legyen (detail-sor nyitás).
        this.templates = list.map((t) => ({ ...t, selected: false }));
        this.rowItems = {};
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },

    createTemplate() {
      this.$router.push("/booking-templates/create");
    },

    editTemplate(item: BookingTemplateListItem) {
      this.$router.push(`/booking-templates/edit/${item.id}`);
    },

    collapseAll() {
      this.templates.forEach((t) => (t.selected = false));
    },

    // Sávok gomb: a tételek táblájának lenyitása/becsukása (lusta betöltés).
    async showItems(item: BookingTemplateListItem) {
      const reopen = !!item.selected && !this.isDeletion;
      this.collapseAll();
      if (reopen) return;
      this.isDeletion = false;
      if (!this.rowItems[item.id]) {
        try {
          const tpl = await api.GetBookingTemplate(item.id);
          this.$set(
            this.rowItems,
            item.id,
            tpl.items.map((it) => ({ ...it, showDimensions: false }))
          );
        }
        catch (e) {
          console.error(e);
          eventBus.$emit("error", t("ASablonTeteleinekBetolteseNemSikerult"));
          return; // hiba esetén ne nyíljon ki üres detail-sor
        }
      }
      item.selected = true;
    },

    // Kuka gomb: a törlés-megerősítő lenyitása/becsukása ugyanabban a detail-sorban.
    askDelete(item: BookingTemplateListItem) {
      const reopen = !!item.selected && this.isDeletion;
      this.collapseAll();
      if (reopen) return;
      this.isDeletion = true;
      item.selected = true;
    },

    async confirmDelete(item: BookingTemplateListItem) {
      item.selected = false;
      try {
        const result = await api.DeleteBookingTemplate(item.id);
        if (!result.success) {
          eventBus.$emit("error", result.message);
          return;
        }
        eventBus.$emit("success", result.message);
        await this.reload();
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", t("GeneralLedger_ASablonTorleseNemSikerult"));
      }
    },

    cancelDelete(item: BookingTemplateListItem) {
      item.selected = false;
    },
  },
});
